import {
  Button,
  Dialog,
  DialogClose,
  DialogContent,
  Typography,
} from '@growdash/design-system/atoms';
import SelectBrand from '@growdash/growintel/components/molecules/select-brand';
import { Brand } from '@growdash/growintel/generated';
import { useOnboarding } from '@growdash/growintel/hooks/useOnboarding';

type Props = {
  tempFirstBrand: Brand | null;
  setTempFirstBrand: React.Dispatch<React.SetStateAction<Brand | null>>;
  tempSecondBrand: Brand | null;
  setTempSecondBrand: React.Dispatch<React.SetStateAction<Brand | null>>;
  onSubmit: any;
};

export default function CompareOnboardingDialog({
  setTempFirstBrand,
  setTempSecondBrand,
  tempFirstBrand,
  tempSecondBrand,
  onSubmit,
}: Props) {
  const { isOnboarded, markAsOnboarded } = useOnboarding('compare');

  if (isOnboarded) return null;

  const handleSubmit = () => {
    markAsOnboarded();
    onSubmit();
  };

  const isSubmitDisabled = !tempFirstBrand || !tempSecondBrand;
  return (
    <Dialog
      defaultOpen
      onOpenChange={(open) => {
        if (!open) {
          markAsOnboarded();
        }
      }}
    >
      <DialogContent className="min-w-fit text-center px-0">
        <div className="w-full px-10">
          <Typography className="font-bold text-2xl">
            Compare your restaurant <br />
            and get customized insights
          </Typography>
          <Typography className="text-sm mt-6">
            Find out how your menu, pricing and ratings compare to similar
            restaurants
          </Typography>
          <Typography className="text-sm mt-2 font-bold">
            Aisha will take care of everything for you.
          </Typography>
          <div className="w-full flex items-center justify-center gap-4 mt-10 mb-6">
            <SelectBrand
              value={tempFirstBrand?.id ?? ''}
              className="transition-all duration-300 "
              onValueChange={setTempFirstBrand}
            />
            <Typography className="text-neutral font-medium text-sm">
              Compare with
            </Typography>

            <SelectBrand
              value={tempSecondBrand?.id ?? ''}
              className="transition-all duration-300 "
              onValueChange={setTempSecondBrand}
            />
          </div>
          <div className="mt-10">
            <DialogClose disabled={isSubmitDisabled}>
              <Button
                onClick={handleSubmit}
                disabled={!tempFirstBrand || !tempSecondBrand}
              >
                Start comparing now
              </Button>
            </DialogClose>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}
